// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"18":"ae100cd8","94":"04d8e03e","606":"7035efe1"}[chunkId] + ".chunk.js";
};